<template>

    <div class="main">
        <slot name="page3" >
            <div >
                <el-row >


                    <el-col  style="padding-top: 50px;" >
                        <div >
                            <el-row>
                                <el-col >
                                    <div style=";font-weight: bold;font-size: 28px;text-align: center;margin-bottom: 20px">Einen artikel der firma.</div>
                                </el-col>
                                <el-col >
                                    <div style="text-align: center">
                                        <hr class="hrLine" style="width:40px;"/> <i style="font-style: normal;color: #db261d;font-weight: bold">Product</i>  <hr class="hrLine" style="width:40px;"/>
                                    </div>

                                </el-col>

                            </el-row>
                        </div>
                    </el-col>


                    <el-col>
                        <div >
                            <el-row>

                                <el-col :xs="24" :sm="24" :md="12" :lg="12" class="product abc" :class="{moveUp:page3Animation}"  style="opacity: 0">
                                    <el-row>
                                        <el-col :xs="8" :sm="8" :md="6" :lg="6" v-for="(item, index) in items" :key="index" >
                                            <button @click="click(index)">{{item}}</button>
                                        </el-col>

                                    </el-row>

                                    <div >
                                        <el-row :class="{moveUp:page3Animation}" class="abc" style="opacity: 0;">

                                            <el-col  :xs="24" :sm="24" :md="18" :lg="18" >
                                                <div class="neirong">
                                                    {{neirong}}
                                                </div>

                                            </el-col>
                                            <el-col :span="24" class="more">
                                                <el-button round @click.native="this.$router.push('/Products')" style="border: 1px solid #db261d;color: #db261d">查看更多 &nbsp;<i class="el-icon-arrow-right"></i></el-button>
                                            </el-col>
                                        </el-row>

                                    </div>
                                </el-col>
                                <el-col :xs="24" :sm="24" :md="12" :lg="12" class="img">
                                    <img :src="require('../../assets/'+imgsrc)" alt="img">
                                </el-col>
                            </el-row>
                        </div>


                    </el-col>

                </el-row>

            </div>
        </slot>

    </div>

</template>

<script>


    export default {
        name: "Page3",

        data(){
            return {

                list:[],
                enter:false,
                isPC:false,
                show:false,
                imgs:null,
                timer:null,
                ScrollViews:true,
                items:["Magnetkern","Geringe Leistung","Hohe Leistung"],
                activeIndex: 1,
                neirongArray:[
                    "Unsere Produkte haben Eigenschaften wie hohe Permeabilität, geringe Koerzitivität, " +
                    "geringe Remanenz und geringe Verluste, was sie weit verbreitet in Leistungstransformatoren, " +
                    "elektronischen Geräten, Motoren, Sensoren, Kältetechnik, medizinischen Erkennungsgeräten, " +
                    "Luft- und Raumfahrtbereichen und mehr macht" ,
                    "Kleine Leistungsmagnetkerne haben typischerweise Eigenschaften wie hohe Effizienz, " +
                    "kleine Größe, stabiler Ausgang, mehrere Schutzfunktionen und einen breiten " +
                    "Eingangsspannungsbereich, was bedeutet, dass sie Energieverluste minimieren, " +
                    "kompakter konstruieren und stabile Ausgangsspannung oder -strom bereitstellen können.",
                    "Hochleistungsmagnetkerne haben typischerweise höhere Effizienz, " +
                    "genauere Leistungsregelung und -überwachung, " +
                    "höhere Leistungsdichte, einfachere Steuerungssysteme, " +
                    "flexiblere Anwendungen in der industriellen Steuerung, " +
                    "High-End-kommerzielle Beleuchtung, Kommunikationsausrüstung, " +
                    "Luft- und Raumfahrt, Server, neue Energie und andere Bereiche"
                ],
                neirong:"Unsere Produkte haben Eigenschaften wie hohe Permeabilität, geringe Koerzitivität, " +
                    "geringe Remanenz und geringe Verluste, was sie weit verbreitet in Leistungstransformatoren, " +
                    "elektronischen Geräten, Motoren, Sensoren, Kältetechnik, medizinischen Erkennungsgeräten, " +
                    "Luft- und Raumfahrtbereichen und mehr macht" ,
                imgArray:[
                    "a144a976cf6267414f0232cce60f277f.png",
                    "06ed73dfeac1c7da9755c244364c9b4c.png",
                    "amhimfjhebfleogpnankdmbpmindbpnj.png"


                ],
                imgsrc: "a144a976cf6267414f0232cce60f277f.png",
                page3Animation:false

            }
        },

        methods:{


            toggleShopShow(){
                this.show= !this.show;
            },
            _isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            },


            click(i){
                this.activeIndex=i
                this.neirong=this.neirongArray[this.activeIndex]
                this.imgsrc=this.imgArray[this.activeIndex]
                switch (i) {
                    case 0 :
                        $(".product button").removeClass("active")
                        $(".product button").eq(0).addClass("active");

                        break;
                    case 1 :
                        $(".product button").removeClass("active")
                        $(".product button").eq(1).addClass("active");
                        break;
                    case 2 :
                        $(".product button").removeClass("active")
                        $(".product button").eq(2).addClass("active");
                        break;


                }
            },
            timeInterval(){


                this.time= setInterval(() => {

                    this.neirong=this.neirongArray[this.activeIndex]
                    this.imgsrc=this.imgArray[this.activeIndex]

                    switch (this.activeIndex) {
                        case 0 :


                            $(".product button").removeClass("active")
                            $(".product button").eq(0).addClass("active");
                            break;
                        case 1 :
                            $(".product button").removeClass("active")
                            $(".product button").eq(1).addClass("active");
                            break;
                        case 2 :
                            $(".product button").removeClass("active")
                            $(".product button").eq(2).addClass("active");
                            break;


                    }
                    this.activeIndex++;
                    if (this.activeIndex==3){
                        this.activeIndex=0
                    }
                }, 4000);

            },
            isInViewPortOfTwo(){
                let that=this
                let target = document.querySelector(".abc");



                const observer = new IntersectionObserver(([entry]) => {
                    if (entry.isIntersecting) {
                        that.enter=true


                    } else {

                        // that.page3Animation=false
                        // .log('元素不在可视范围内');
                    }
                }, { threshold: 0.3 }); // 阈值设置为0.1，表示元素进入可视范围10%时触发回调函数
                observer.observe(target); // 开始监听元素


            },
            scrolling(){
                this.isInViewPortOfTwo()
            },
            DestroyListener() {
                this.ScrollViews=false
                clearInterval(this.time)
                window.removeEventListener('scroll', this.scrolling);


            },
        },


        mounted(){
            $(".product button").eq(0).addClass("active");
            //监听滚动条
            window.addEventListener("scroll", this.scrolling);
            this.timeInterval();

            if (this._isMobile()) {
                if(this._isMobile().indexOf("iPad")!=-1){
                    this.isPC=true;
                }else {
                    this.isPC=false;
                }

            } else {

                this.isPC=true;
            }


        },


        watch:{
            enter:{
                handler(news,old){
                    if (news==true){
                        this.page3Animation=true

                    }

                }
            }
        }


    }
</script>

<style lang="less" scoped>
    .hrLine{
        vertical-align:middle; display:inline-block;
    }
    a{
        text-decoration: none;
        color: black;
    }
    .main{
        min-height: 100vh;

        background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.5) 100%);

    }

    .product>.el-row{
        padding: 100px 30px 30px 80px;
    }
    .product .el-row:last-child{
        padding: 50px 30px 30px 80px;
    }
    .product>.el-row .el-col{
        text-align: center;
        line-height: 30px;
        border-right: 1px solid rgba(105, 105, 105, 0.5);
        font-size: 1rem;
        font-family: HarmonyOS_Sans_SC_Medium;
        transition: all 0.8s ease
    }
    .product .el-row .el-col:last-child{
        border-right: none;
    }
    .abc div{
        font-size: 1.5rem;line-height: 50px;font-family: HarmonyOS_Sans_SC_Medium;
    }

    .img{
        padding: 50px 30px 30px 30px;
        height: 100%
    }
    .img img{
        width: 100%;
        height: 100%;
    }
    .active{
        font-family: HarmonyOS_Sans_SC_Bold !important;
    }
    .product>.el-row button{
        border: none;
        font-size: 1rem;
        background: transparent;
    }
    .product>.el-row button:hover{
        cursor: pointer;
    }

    .neirong{
        min-height: 65vh;
        animation: moveUp 2s ease-in-out forwards;


    }
    /*移动端*/
    @media screen and (max-width:768px){
        .product>.el-row{

            padding: 10px;
            /*margin-left: -25px;*/
        }

        .product>.el-row .el-col{

            text-align: center;
            line-height: 30px;
            border-right: 1px solid rgba(105, 105, 105, 0.5);
            font-size: 0.8rem !important;
            font-family: HarmonyOS_Sans_SC_Medium;
        }
        .product .el-row .el-col:last-child{
            border-right: none;
        }
        .abc div{
            font-size: 1rem;line-height: 30px;font-family: HarmonyOS_Sans_SC_Medium;
        }
        .product .el-row:last-child{
            padding: 20px;
        }
        .more{
            margin-top: 10px;
        }

        img{
            margin-top: -50px;
        }

        .main{
            min-height: 80vh;
            overflow: hidden;

            background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.5) 100%);

        }
        .neirong{
            min-height: unset;


        }
        .more{
            margin-top: 50px;
        }
    }
</style>
